'use client';
import { GTM_SOURCE } from './domain.js';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const getDataLayerParam = (key)=>key != 'dataLayer' ? '&l=' + key : '';
const initializeGA = (config)=>{
    var _containerElement_parentNode;
    const { scriptSource = GTM_SOURCE, key = 'dataLayer', scriptTag = 'script', containerId } = config;
    if (!containerId) {
        throw new Error('Для плагина аналитики "GA" не задан containerId!');
    }
    window[key] = window[key] || [];
    window[key].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    const containerElement = document.getElementsByTagName(scriptTag)[0];
    const scriptElement = document.createElement(scriptTag);
    const dataLayerParam = getDataLayerParam(key);
    scriptElement.async = true;
    scriptElement.src = `${scriptSource}?id=${containerId}${dataLayerParam}`;
    containerElement == null ? void 0 : (_containerElement_parentNode = containerElement.parentNode) == null ? void 0 : _containerElement_parentNode.insertBefore(scriptElement, containerElement);
};

export { getDataLayerParam, initializeGA };
//# sourceMappingURL=initializer.js.map
